import { Question } from "../../interfaces/purchase-order.interface";
import { QuestionType } from "../../enums/question-type.enum";
import { EntitiesQuestions } from "./entities.questions";
import { cloneDeep } from "lodash";

export class CirculationCardQuestions {
  public static question_invoice_main: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio-question-select",
      question_confirm: "¿Se pudo consultar la información del comprobante con el código QR?",
      answer_confirm: undefined,
      open_select: "yes",
      control: "qr_scanned",
      options: [
        { label: "Sí", value: { value: "yes", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe ser legible: en tamaño carta y con buena nitidez, no se detectó información ni se pudo leer el código QR.",
          },
        },
      ],
      answer: undefined,
      label: "¿Qué medio usaste?",
      select_options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Consulta Manual", value: { value: "Consulta Manual", incident: false } },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La información del anverso y reverso es del mismo vehículo?",
      formatted_question: "¿La información del anverso y reverso es del <b>mismo vehículo</b>?",
      control: "data_coincidence_front_reverse",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "La información del anverso y el reverso del documento debe de coincidir.",
          },
        },
      ],
      page: 2,
    },
    {
      type: "radio-textbox",
      question: "¿La tarjeta tiene un folio de trámite?",
      formatted_question: "¿La tarjeta tiene un <b>folio</b> de trámite?",
      label: "Captura el Folio",
      control: "card_with_sheet",
      options: [
        { label: "Sí", value: { value: "other", incident: false, show_alternative_question: true } },
        { label: "No", value: { value: "no", incident: true, show_alternative_question: false } },
      ],
      page: 2,
      additional_note:
        "La ausencia de folio no es una incidencia a corregir pero quedará registrada como una observación para el área de Operaciones.",
    },
    {
      type: "radio",
      question: "¿El titular coincide con el último propietario de la cadena de facturación?",
      control: "billing_chain_same_person",
      options: [
        { label: "Sí", value: { value: "other", incident: false, show_alternative_question: true } },
        { label: "No", value: { value: "no", incident: true, show_alternative_question: false } },
      ],
      page: 3,
      additional_data: "",
      additional_note:
        "Esta tarjeta no corresponde con el cliente más reciente, no es una incidencia a corregir pero quedará registrada como una observación para el área de Operaciones.",
    },
  ];

  public static additional_questions: Question[] = [
    {
      type: "select",
      question: "",
      control: "belong_city",
      label: "Entidad",
      options: cloneDeep(EntitiesQuestions.question_entities),
      page: 1,
    },
    {
      type: "select",
      question: "",
      control: "list_plates",
      label: "Número de placa",
      options: [],
      page: 1,
    },
    {
      type: "date-picker",
      question: "",
      control: "document_expiration",
      label: "Vigencia de la tarjeta",
      answer: undefined,
      page: 1,
    },
  ];
}
